<script lang="ts">
	// Byline visible affichée en haut des guides : auteur générique (équipe),
	// dates au format français, durée de lecture, audience cible.
	// Doublonne volontairement les dates du JSON-LD pour le signal humain (E-E-A-T).
	let {
		published,
		updated,
		readingTime,
		audience
	}: {
		published: string;
		updated: string;
		readingTime: number;
		audience: string;
	} = $props();

	const FR_MONTHS = [
		'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
		'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
	];

	function formatFr(iso: string): string {
		const [y, m, d] = iso.split('-').map(Number);
		return `${d} ${FR_MONTHS[m - 1]} ${y}`;
	}

	const publishedFr = $derived(formatFr(published));
	const updatedFr = $derived(formatFr(updated));
	const isUpdated = $derived(published !== updated);
</script>

<p class="mt-6 text-sm text-ash">
	Article rédigé avec l'IA et édité par <span class="font-medium text-ink">Fiche Séquence</span>
	· Publié le {publishedFr}{#if isUpdated}&nbsp;· Mis à jour le {updatedFr}{/if}
	· {readingTime} min de lecture · {audience}
</p>
